const PATH_PLACEHOLDER_VALUES: Record<string, string> = {
    activationId: "",
    campaignId: "",
    countryCode: "999",
    timeRange: "7d",
    isWWW: "*",
};

const QUERY_PLACEHOLDER_VALUES: Record<string, string> = {
    campaignId: "",
    timeRange: "7d",
    device: "MobileWeb",
    openCampaignPicker: "false",
    model: "all",
    AIModel: "all",
};

const PLACEHOLDER_PATTERN = /\{([a-zA-Z][a-zA-Z0-9_]*)\}/g;

const substitutePlaceholders = (segment: string, map: Record<string, string>): string =>
    segment.replace(PLACEHOLDER_PATTERN, (full, name: string) => (name in map ? (map[name] ?? "") : full));

const resolveQueryPlaceholders = (query: string): string => {
    if (!query) {
        return "";
    }

    const parts: string[] = [];

    for (const raw of query.split("&")) {
        const part = raw.trim();
        if (!part) {
            continue;
        }

        const braceMatch = /^\{([a-zA-Z][a-zA-Z0-9_]*)\}$/.exec(part);
        if (!braceMatch) {
            parts.push(part);
            continue;
        }

        const name = braceMatch[1];
        const value = QUERY_PLACEHOLDER_VALUES[name];
        if (value === undefined || value === "") {
            continue;
        }

        parts.push(`${name}=${value}`);
    }

    return parts.join("&");
};

/**
 * Replaces `{placeholder}` segments from the Quick Search pages catalog with static defaults
 * so hash URLs are valid before navigation.
 */
export const resolveQuickSearchCatalogPageUrl = (url: string): string => {
    const normalized = url.startsWith("#") ? url : `#${url}`;
    const queryIdx = normalized.indexOf("?");
    const pathPart = queryIdx === -1 ? normalized : normalized.slice(0, queryIdx);
    const queryPart = queryIdx === -1 ? "" : normalized.slice(queryIdx + 1);

    const pathResolved = substitutePlaceholders(pathPart, PATH_PLACEHOLDER_VALUES);
    const queryResolved = resolveQueryPlaceholders(queryPart);

    return queryResolved ? `${pathResolved}?${queryResolved}` : pathResolved;
};
